<div class="ai-text">
  <!-- Reference images (if present in user message meta) -->
  <div class="reference-images" *ngIf="message.meta?.referenceImages?.length">
    <div class="ref-image-label">Reference Images:</div>
    <div class="ref-images-grid">
      <img *ngFor="let img of message.meta.referenceImages" [src]="img.url" [alt]="'Reference image'" class="ref-image-thumb" />
    </div>
  </div>

  <div class="bubble">
    {{ message.content }}
  </div>
</div>


